// Renders a branded scripture card to a PNG and shares/downloads it.
const BRAND = "In His Image Radio";

function wrapText(ctx, text, maxWidth) {
  const words = text.split(" ");
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? line + " " + w : w;
    if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = w; }
    else line = test;
  }
  if (line) lines.push(line);
  return lines;
}

export async function shareVerseImage({ text, reference }) {
  const S = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = S; canvas.height = S;
  const ctx = canvas.getContext("2d");
  const g = ctx.createLinearGradient(0, 0, S, S);
  g.addColorStop(0, "#141C42"); g.addColorStop(1, "#0A1030");
  ctx.fillStyle = g; ctx.fillRect(0, 0, S, S);
  ctx.strokeStyle = "rgba(230,179,74,0.35)"; ctx.lineWidth = 4;
  ctx.strokeRect(50, 50, S - 100, S - 100);
  ctx.fillStyle = "#E6B34A"; ctx.textAlign = "center";
  ctx.font = "600 30px Georgia, serif";
  ctx.fillText("VERSE OF THE DAY", S / 2, 165);

  // fit font size to text length
  let size = text.length > 220 ? 40 : text.length > 120 ? 50 : 60;
  ctx.font = `700 ${size}px Georgia, serif`;
  ctx.fillStyle = "#FFFFFF";
  const lines = wrapText(ctx, `"${text}"`, S - 220);
  const lineH = size * 1.35;
  const startY = S / 2 - (lines.length * lineH) / 2;
  lines.forEach((ln, i) => ctx.fillText(ln, S / 2, startY + i * lineH));

  ctx.fillStyle = "#E6B34A";
  ctx.font = "italic 700 42px Georgia, serif";
  ctx.fillText(reference, S / 2, startY + lines.length * lineH + 55);
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "500 30px Georgia, serif";
  ctx.fillText(BRAND, S / 2, S - 110);

  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const file = new File([blob], "verse.png", { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: "Scripture", text: `${reference} — via ${BRAND}` });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = `verse-${reference.replace(/[^a-z0-9]+/gi, "-")}.png`;
  a.click();
  URL.revokeObjectURL(url);
  return "downloaded";
}
